import { ErrorMessage, Field, Form, Formik } from "formik";
import React from "react";
import * as Yup from "yup";
import appStyles from "../../../app.module.css";
import ErrorMsg from "../../components/error-msg/error-msg";

const initialValues = {
	buyer_disbursment: "",
	seller_disbursment: "",
	govt_enquiry_fee: "",
	electronic_conveyancing_fee: "",
	verification_identity_fee: "",
	strata_titles_act_sec_110_certificate: "",
	landgate_discharge_of_mortgage: "",
	apr_or_sa_per_application: "",
	inperson_settlement_attendance: "",
	privacy_compliance_fee: "",
};

const validationSchema = Yup.object().shape({
	buyer_disbursment: Yup.number()
		.required("Buyer disbursment is required")
		.moreThan(0, "Buyer disbursment is required"),
	seller_disbursment: Yup.number()
		.required("Seller disbursment is required")
		.moreThan(0, "Seller disbursment is required"),
	govt_enquiry_fee: Yup.number()
		.required("Govt. enquiry fee is required")
		.moreThan(0, "Govt. enquiry fee is required"),
	electronic_conveyancing_fee: Yup.number()
		.required("Electronic conveyancing fee is required")
		.moreThan(0, "Electronic conveyancing fee is required"),
	verification_identity_fee: Yup.number()
		.required("Verification of Identity fee (per person) is required")
		.moreThan(0, "Verification of Identity fee (per person) is required"),
	strata_titles_act_sec_110_certificate: Yup.number()
		.required("Strata titles act sec 110 certificate is required")
		.moreThan(0, "Strata titles act sec 110 certificate is required"),
	landgate_discharge_of_mortgage: Yup.number()
		.required("Landgate discharge of mortgage fee is required")
		.moreThan(0, "Landgate discharge of mortgage fee is required"),
	apr_or_sa_per_application: Yup.number()
		.required("APR or SA (per application) is required")
		.moreThan(0, "APR or SA (per application) is required"),
	inperson_settlement_attendance: Yup.number()
		.required("Inperson settlement attendance is required")
		.moreThan(0, "Inperson settlement attendance is required"),
	privacy_compliance_fee: Yup.number()
		.required("Privacy compliance fee is required")
		.moreThan(0, "Privacy compliance fee is required"),
});

const AddEditExtraFee = (props) => {
	const { extraFee, error } = props;

	const onSubmit = (values) => {
		props.submit(values);
	};

	return (
		<>
			<div className={appStyles.rezziModal}>
				<div className={appStyles.rezziModalOverlay}></div>
				<div className={appStyles.rezziModalContent}>
					<Formik
						initialValues={extraFee.id ? extraFee : initialValues}
						validationSchema={validationSchema}
						onSubmit={onSubmit}
					>
						{({ values, touched, errors }) => (
							<Form>
								<div className={appStyles.rezziModalHeader}>
									<h2
										className={`${appStyles.textCenter} ${appStyles.colorPrimary}`}
									>
										{extraFee.id
											? "Edit Extra Fee"
											: "Add Extra Fee"}
									</h2>
								</div>
								<div className={appStyles.rezziModalBody}>
									<div className={appStyles.formRow}>
										<div
											className={`${
												appStyles.formField
											} ${
												values.buyer_disbursment ||
												values.buyer_disbursment === 0
													? appStyles.hasValue
													: ""
											} ${
												touched.buyer_disbursment &&
												errors.buyer_disbursment
													? appStyles.hasError
													: ""
											}`}
										>
											<Field
												type="number"
												id="buyer_disbursment"
												name="buyer_disbursment"
											/>
											<label htmlFor="buyer_disbursment">
												Buyer Disbursment
											</label>
											<ErrorMessage
												name="buyer_disbursment"
												component={ErrorMsg}
											/>
										</div>
									</div>
									<div className={appStyles.formRow}>
										<div
											className={`${
												appStyles.formField
											} ${
												values.seller_disbursment ||
												values.seller_disbursment === 0
													? appStyles.hasValue
													: ""
											} ${
												touched.seller_disbursment &&
												errors.seller_disbursment
													? appStyles.hasError
													: ""
											}`}
										>
											<Field
												type="number"
												id="seller_disbursment"
												name="seller_disbursment"
											/>
											<label htmlFor="seller_disbursment">
												Seller Disbursment
											</label>
											<ErrorMessage
												name="seller_disbursment"
												component={ErrorMsg}
											/>
										</div>
									</div>
									<div className={appStyles.formRow}>
										<div
											className={`${
												appStyles.formField
											} ${
												values.govt_enquiry_fee ||
												values.govt_enquiry_fee === 0
													? appStyles.hasValue
													: ""
											} ${
												touched.govt_enquiry_fee &&
												errors.govt_enquiry_fee
													? appStyles.hasError
													: ""
											}`}
										>
											<Field
												type="number"
												id="govt_enquiry_fee"
												name="govt_enquiry_fee"
											/>
											<label htmlFor="govt_enquiry_fee">
												Govt. Enquiry Fee
											</label>
											<ErrorMessage
												name="govt_enquiry_fee"
												component={ErrorMsg}
											/>
										</div>
									</div>
									<div className={appStyles.formRow}>
										<div
											className={`${
												appStyles.formField
											} ${
												values.electronic_conveyancing_fee ||
												values.electronic_conveyancing_fee ===
													0
													? appStyles.hasValue
													: ""
											} ${
												touched.electronic_conveyancing_fee &&
												errors.electronic_conveyancing_fee
													? appStyles.hasError
													: ""
											}`}
										>
											<Field
												type="number"
												id="electronic_conveyancing_fee"
												name="electronic_conveyancing_fee"
											/>
											<label htmlFor="electronic_conveyancing_fee">
												Electronic Conveyancing Fee
											</label>
											<ErrorMessage
												name="electronic_conveyancing_fee"
												component={ErrorMsg}
											/>
										</div>
									</div>
									<div className={appStyles.formRow}>
										<div
											className={`${
												appStyles.formField
											} ${
												values.verification_identity_fee ||
												values.verification_identity_fee ===
													0
													? appStyles.hasValue
													: ""
											} ${
												touched.verification_identity_fee &&
												errors.verification_identity_fee
													? appStyles.hasError
													: ""
											}`}
										>
											<Field
												type="number"
												id="verification_identity_fee"
												name="verification_identity_fee"
											/>
											<label htmlFor="verification_identity_fee">
												Verification of Identity fee
												(per person)
											</label>
											<ErrorMessage
												name="verification_identity_fee"
												component={ErrorMsg}
											/>
										</div>
									</div>
									<div className={appStyles.formRow}>
										<div
											className={`${
												appStyles.formField
											} ${
												values.strata_titles_act_sec_110_certificate ||
												values.strata_titles_act_sec_110_certificate ===
													0
													? appStyles.hasValue
													: ""
											} ${
												touched.strata_titles_act_sec_110_certificate &&
												errors.strata_titles_act_sec_110_certificate
													? appStyles.hasError
													: ""
											}`}
										>
											<Field
												type="number"
												id="strata_titles_act_sec_110_certificate"
												name="strata_titles_act_sec_110_certificate"
											/>
											<label htmlFor="strata_titles_act_sec_110_certificate">
												Strata Titles Act Sec 110
												Certificate
											</label>
											<ErrorMessage
												name="strata_titles_act_sec_110_certificate"
												component={ErrorMsg}
											/>
										</div>
									</div>
									<div className={appStyles.formRow}>
										<div
											className={`${
												appStyles.formField
											} ${
												values.landgate_discharge_of_mortgage ||
												values.landgate_discharge_of_mortgage ===
													0
													? appStyles.hasValue
													: ""
											} ${
												touched.landgate_discharge_of_mortgage &&
												errors.landgate_discharge_of_mortgage
													? appStyles.hasError
													: ""
											}`}
										>
											<Field
												type="number"
												id="landgate_discharge_of_mortgage"
												name="landgate_discharge_of_mortgage"
											/>
											<label htmlFor="landgate_discharge_of_mortgage">
												Landgate Discharge of Mortgage
												Fee
											</label>
											<ErrorMessage
												name="landgate_discharge_of_mortgage"
												component={ErrorMsg}
											/>
										</div>
									</div>
									<div className={appStyles.formRow}>
										<div
											className={`${
												appStyles.formField
											} ${
												values.apr_or_sa_per_application ||
												values.apr_or_sa_per_application ===
													0
													? appStyles.hasValue
													: ""
											} ${
												touched.apr_or_sa_per_application &&
												errors.apr_or_sa_per_application
													? appStyles.hasError
													: ""
											}`}
										>
											<Field
												type="number"
												id="apr_or_sa_per_application"
												name="apr_or_sa_per_application"
											/>
											<label htmlFor="apr_or_sa_per_application">
												APR or SA (Per Application)
											</label>
											<ErrorMessage
												name="apr_or_sa_per_application"
												component={ErrorMsg}
											/>
										</div>
									</div>
									<div className={appStyles.formRow}>
										<div
											className={`${
												appStyles.formField
											} ${
												values.inperson_settlement_attendance ||
												values.inperson_settlement_attendance ===
													0
													? appStyles.hasValue
													: ""
											} ${
												touched.inperson_settlement_attendance &&
												errors.inperson_settlement_attendance
													? appStyles.hasError
													: ""
											}`}
										>
											<Field
												type="number"
												id="inperson_settlement_attendance"
												name="inperson_settlement_attendance"
											/>
											<label htmlFor="inperson_settlement_attendance">
												Inperson Settlement Attendance
											</label>
											<ErrorMessage
												name="inperson_settlement_attendance"
												component={ErrorMsg}
											/>
										</div>
									</div>

									<div className={appStyles.formRow}>
										<div
											className={`${
												appStyles.formField
											} ${
												values.privacy_compliance_fee ||
												values.privacy_compliance_fee ===
													0
													? appStyles.hasValue
													: ""
											} ${
												touched.privacy_compliance_fee &&
												errors.privacy_compliance_fee
													? appStyles.hasError
													: ""
											}`}
										>
											<Field
												type="number"
												id="privacy_compliance_fee"
												name="privacy_compliance_fee"
											/>
											<label htmlFor="privacy_compliance_fee">
												Privacy compliance fee
											</label>
											<ErrorMessage
												name="privacy_compliance_fee"
												component={ErrorMsg}
											/>
										</div>
									</div>
								</div>
								<div className={appStyles.rezziModalFooter}>
									<button type="submit">Save</button>
									<button
										className={appStyles.buttonOutline}
										onClick={props.close}
									>
										Close
									</button>
								</div>
								{error && (
									<div className={appStyles.colorDanger}>
										{error}
									</div>
								)}
							</Form>
						)}
					</Formik>
				</div>
			</div>
		</>
	);
};

export default AddEditExtraFee;
